import React from "react";

export default function Plans() {
  return (
    <div className="p-6 text-center">
      <h1 className="text-2xl font-bold mb-4">Reports & Analytics</h1>
      <p className="text-gray-600">View and edit client support and care plans.</p>
    </div>
  );
}
